import {
  Avatar,
  Box,
  Checkbox,
  Radio,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
  useTheme,
} from "@material-ui/core";
import { CheckBoxOutlineBlank, RadioButtonUnchecked } from "@material-ui/icons";
import React, { useCallback } from "react";
import { EmptyComponent } from "../../components";
import {
  beutifyText,
  isImage,
  isNumber,
  showImageModal,
} from "../../helper/common.helper";
import style from "./style";

interface ITableProps {
  header: string[];
  includeRank?: boolean;
  data: { [key: string]: any }[];
  fields: string[];
  rankStart?: number;
  color?: string;
}

export const AggregationRow: React.FC<{
  fields: string[];
  rank: number;
  color: string;
  selectable?: boolean;
  multiSelect?: boolean;
  onSelect?: (values: any) => void;
  value: { [key: string]: any };
}> = ({ fields, value, rank, color, selectable, multiSelect, onSelect }) => {
  const theme = useTheme();
  const classes = style();

  const openModal = useCallback((url: string) => showImageModal(url), []);

  return (
    <TableRow>
      {selectable && (
        <TableCell>
          {!multiSelect ? (
            <Radio
              color="primary"
              icon={<RadioButtonUnchecked color="primary" />}
              onClick={() => onSelect && onSelect(value)}
            />
          ) : (
            <Checkbox
              color="primary"
              icon={<CheckBoxOutlineBlank color="primary" />}
              onClick={() => onSelect && onSelect(value)}
            />
          )}
        </TableCell>
      )}
      {Boolean(rank) && <TableCell style={{ color }}>{rank}</TableCell>}
      {fields.map((key) => (
        <TableCell
          key={key}
          style={{
            color,
            width: 300,
          }}
        >
          {isImage(value[key]) ? (
            <Box
              className={classes.imageView}
              onClick={() => openModal(value[key])}
            >
              <Avatar
                alt={key}
                variant="rounded"
                src={value[key]}
                style={{
                  height: theme.spacing(7),
                  width: theme.spacing(7),
                }}
              />
            </Box>
          ) : value[key] === null ? (
            "N/A"
          ) : isNumber(value[key]) ? (
            <Tooltip title={`${key} ${value[key]}`}>
              <Typography>{beutifyText(value[key] as number)}</Typography>
            </Tooltip>
          ) : (
            <Tooltip title={value[key] ? value[key] : "N/A"} placement="bottom">
              <Typography
                style={{
                  maxWidth: 300,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {value[key]}
              </Typography>
            </Tooltip>
          )}
        </TableCell>
      ))}
    </TableRow>
  );
};

const AggregationTable: React.FC<ITableProps> = ({
  header,
  includeRank,
  data,
  fields,
  rankStart,
  color,
}) => {
  const classes = style();
  return (
    <Table>
      <TableHead>
        <TableRow>
          {Boolean(includeRank) && (
            <TableCell
              style={{ color }}
              classes={{ stickyHeader: classes.stickyHeader }}
            >
              Rank
            </TableCell>
          )}
          {header.map((element) => (
            <TableCell
              key={element}
              style={{ color }}
              classes={{ stickyHeader: classes.stickyHeader }}
            >
              {element}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>

      <TableBody>
        {!(data || []).length ? (
          <TableRow>
            <TableCell colSpan={fields.length + 1}>
              <EmptyComponent content="No data found" />
            </TableCell>
          </TableRow>
        ) : (
          data.map((element, index) => (
            <AggregationRow
              color={color || "white"}
              rank={
                includeRank
                  ? rankStart
                    ? rankStart + index + 1
                    : index + 1
                  : 0
              }
              value={element}
              fields={fields}
            />
          ))
        )}
      </TableBody>
    </Table>
  );
};

AggregationTable.defaultProps = {
  color: "white",
};

export default AggregationTable;
